exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.consent-terms[data-v-1bdcd2a8] {\n  font-family: inherit;\n  font-size: 15px;\n  line-height: 1.6;\n  text-align: justify;\n  color: #4c4d4f;\n  padding: 8px 24px 24px;\n  white-space: normal;\n  word-wrap: break-word;\n}\n.consent-terms h2[data-v-1bdcd2a8] {\n  font-size: 20px;\n  font-weight: 700;\n  text-align: center;\n  line-height: 1.3;\n  margin: 8px 0 24px;\n}\n.consent-terms-actions[data-v-1bdcd2a8] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding: 0 24px 24px;\n}\n", ""]);

// exports
